module.exports = __webpack_public_path__ + "img/yhmc.b54b1d10.png";